import { useVeriff } from './useVeriff'

function VeriffRoot() {
  const { veriffRootId } = useVeriff()
  return (
    <div
      id={veriffRootId}
      className="hidden mb-[15px] max-w-[992px] min-w-0 [&_.veriff-description]:hidden [&_input.veriff-submit]:hidden [&_input.veriff-submit]:h-[64px] [&_input.veriff-submit]:min-w-[250px] [&_input.veriff-submit]:items-center [&_input.veriff-submit]:justify-center [&_input.veriff-submit]:rounded-[12px] [&_input.veriff-submit]:border-none [&_input.veriff-submit]:text-[16px] [&_input.veriff-submit]:font-medium [&_input.veriff-submit]:shadow-[0_4px_14px_rgba(10,8,58,0.1)] [&_input.veriff-submit:hover]:no-underline"
    />
  )
}

export { VeriffRoot }
